function SvgAIBuilder({ ...props }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x="3.5" y="3.5" width="17" height="17" rx="2.5" stroke="currentColor" />
      <path d="M17.2971 16.125H15.5154V7.875H17.2971V16.125Z" fill="currentColor" />
      <path
        d="M14.7029 15.875H12.8328L12.3594 14.5197H9.05786L8.57301 15.875H6.70288L9.68124 7.875H11.7361L14.7029 15.875ZM11.9092 13.0204L10.7087 9.57815L9.50808 13.0204H11.9092Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgAIBuilder;
